import { FormikErrors } from 'formik';

export const MIN_PRICE = 99;

export const RANGE_POSITIONS = [5, 15, 50, 85, 95];

export const validateVehiclePrice = (price?: number): FormikErrors<{ vehiclePrice: number | undefined }> => {
  const errors: FormikErrors<{ vehiclePrice: number | undefined }> = {};

  if (!price || !Number.isInteger(Number(price))) {
    errors.vehiclePrice = 'Veuillez renseigner un prix valide. Celui-ci ne doit contenir que des chiffres.';
  } else if (Number(price) <= MIN_PRICE) {
    errors.vehiclePrice = `Veuillez renseigner un prix supérieur à ${MIN_PRICE}`;
  }
  return errors;
};
